import {
  getServiceSales,
  getPopularServiceSales,
  getRetailProducts,
  getPopularRetailProducts,
  getCoupons,
  getPopularCoupons,
} from "@/services/estore";
import {
  getTodaysDate
} from "@/common/helpers/DateTimeHelper.js";
import {
  formatProcessingTime
 } from "@/common/helpers/ProductHelper";

const state = {
  serviceSales: null,
  popularServiceSales: null,
  retailProducts: null,
  popularRetailProducts: null,
  coupons: null,
  popularCoupons: null,
};

const getters = {
  serviceSales: (state) => state.serviceSales,
  popularServiceSales: (state) => state.popularServiceSales,
  retailProducts: (state) => state.retailProducts,
  popularRetailProducts: (state) => state.popularRetailProducts,
  coupons: (state) => state.coupons,
  popularCoupons: (state) => state.popularCoupons,
};

const actions = {
  async getServiceSales({ commit }) {
    try {
      const response = await getServiceSales();
      commit("getServiceSales", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getPopularServiceSales({ commit }) {
    try {
      const response = await getPopularServiceSales();
      commit("getPopularServiceSales", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getRetailProducts({ commit }) {
    try {
      const response = await getRetailProducts();
      commit("getRetailProducts", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getPopularRetailProducts({ commit }) {
    try {
        const response = await getPopularRetailProducts();
        commit("getPopularRetailProducts", response.data);
    } catch (error) {
        console.log(error);
    }
  },
  async getCoupons({ commit }) {
    try {
      const response = await getCoupons();
      commit("getCoupons", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async getPopularCoupons({ commit }) {
    try {
      const response = await getPopularCoupons();
      commit("getPopularCoupons", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  // reset estore all popular products type and all products type
  resetEstoreProducts({ commit }) {
    commit("resetEstoreProducts", null);
  }
};

const mutations = {
  getServiceSales(state, data) {
    const todaysDate = getTodaysDate();

    state.serviceSales = data.map((item) => {
      const itemLine = item.service;

      if (
        !(
          itemLine.startDate <= todaysDate &&
          itemLine.endDate >= todaysDate
        )
      ) {
        item.promotion = false;
        // Set normal price as sell price
        item.salePrice = item.price;
        // Set original price empty
        item.originalPrice = "";
      } else if (itemLine.limitQty === 0) {
        item.promotion = true;
        // Set promotionPrice as current salePrice
        item.salePrice = itemLine.promotionPrice;
        // Set price as original price
        item.originalPrice = item.price;
      } else if (itemLine.unitRemain > 0) {
        item.promotion = true;
        item.salePrice = itemLine.promotionPrice;
        item.originalPrice = item.price;
      } else {
        item.promotion = false;
        item.salePrice = item.price;
        item.originalPrice = "";
      }
      item.service.formatProcessingTime = formatProcessingTime(item.type, itemLine.processingTime);

      return item;
    });
  },
  getPopularServiceSales(state, data) {
    const todaysDate = getTodaysDate();

    state.popularServiceSales = data.map((item) => {
      const itemLine = item.service;

      if (
        !(
          itemLine.startDate <= todaysDate &&
          itemLine.endDate >= todaysDate
        )
      ) {
        item.promotion = false;
        // Set normal price as sell price
        item.salePrice = item.price;
        // Set original price empty
        item.originalPrice = "";
      } else if (itemLine.limitQty === 0) {
        item.promotion = true;
        // Set promotionPrice as current salePrice
        item.salePrice = itemLine.promotionPrice;
        // Set price as original price
        item.originalPrice = item.price;
      } else if (itemLine.unitRemain > 0) {
        item.promotion = true;
        item.salePrice = itemLine.promotionPrice;
        item.originalPrice = item.price;
      } else {
        item.promotion = false;
        item.salePrice = item.price;
        item.originalPrice = "";
      }
      item.service.formatProcessingTime = formatProcessingTime(item.type, itemLine.processingTime);

      return item;
    });
  },
  getRetailProducts(state, data) {
    const todaysDate = getTodaysDate();

    state.retailProducts = data.map((item) => {
      const itemLine = item.retailProduct;

      if (
        !(
          itemLine.startDate <= todaysDate &&
          itemLine.endDate >= todaysDate
        )
      ) {
        item.promotion = false;
        // Set normal price as sell price
        item.salePrice = item.price;
        // Set original price empty
        item.originalPrice = "";
      } else if (itemLine.limitQty === 0) {
        item.promotion = true;
        // Set promotionPrice as current salePrice
        item.salePrice = itemLine.promotionPrice;
        // Set price as original price
        item.originalPrice = item.price;
      } else if (itemLine.unitRemain > 0) {
        item.promotion = true;
        item.salePrice = itemLine.promotionPrice;
        item.originalPrice = item.price;
      } else {
        item.promotion = false;
        item.salePrice = item.price;
        item.originalPrice = "";
      }
      // manually set default value, no need call formatProcessingTime since retail product don't has processing time
      item.retailProduct.formatProcessingTime = '-';

      return item;
    });
  },
  getPopularRetailProducts(state, data) {
    const todaysDate = getTodaysDate();

    state.popularRetailProducts = data.map((item) => {
      const itemLine = item.retailProduct;

      if (
        !(
          itemLine.startDate <= todaysDate &&
          itemLine.endDate >= todaysDate
        )
      ) {
        item.promotion = false;
        // Set normal price as sell price
        item.salePrice = item.price;
        // Set original price empty
        item.originalPrice = "";
      } else if (itemLine.limitQty === 0) {
        item.promotion = true;
        // Set promotionPrice as current salePrice
        item.salePrice = itemLine.promotionPrice;
        // Set price as original price
        item.originalPrice = item.price;
      } else if (itemLine.unitRemain > 0) {
        item.promotion = true;
        item.salePrice = itemLine.promotionPrice;
        item.originalPrice = item.price;
      } else {
        item.promotion = false;
        item.salePrice = item.price;
        item.originalPrice = "";
      }
      // manually set default value, no need call formatProcessingTime since retail product don't has processing time
      item.retailProduct.formatProcessingTime = '-';

      return item;
    });
  },
  getCoupons(state, data) {
    const todaysDate = getTodaysDate();

    state.coupons = data.map((item) => {
      const itemLine = item.coupon;

      if (
        itemLine.startDate <= todaysDate &&
        itemLine.endDate >= todaysDate
      ) {
        item.promotion = true;
        item.salePrice = itemLine.promotionPrice;
        item.originalPrice = item.price;
      } else {
        item.promotion = false;
        item.salePrice = item.price;
        item.originalPrice = "";
      }
      // manually set default value, no need call formatProcessingTime since coupon don't has processing time
      item.coupon.formatProcessingTime = '-';

      return item;
    });
  },
  getPopularCoupons(state, data) {
    const todaysDate = getTodaysDate();

    state.popularCoupons = data.map((item) => {
      const itemLine = item.coupon;

      if (
        itemLine.startDate <= todaysDate &&
        itemLine.endDate >= todaysDate
      ) {
        item.promotion = true;
        item.salePrice = itemLine.promotionPrice;
        item.originalPrice = item.price;
      } else {
        item.promotion = false;
        item.salePrice = item.price;
        item.originalPrice = "";
      }
      // manually set default value, no need call formatProcessingTime since coupon don't has processing time
      item.coupon.formatProcessingTime = '-';

      return item;
    });
  },
  resetEstoreProducts(state, data) {
    state.serviceSales = data;
    state.popularServiceSales = data;
    state.retailProducts = data;
    state.popularRetailProducts = data;
    state.coupons = data;
    state.popularCoupons = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
